import * as React from 'react';

import {
  CountryCard,
  GenderAgeCard,
  LanguageEthnicityCard,
  ProfileCard,
  SummaryCard,
} from '../Card';

import styles from './Content.scss';

export const TiktokContent: React.FC = () => (
  <div className={styles.summary}>
    <ProfileCard className={styles.ProfileCard} />
    <SummaryCard className={styles.SummaryCard} />
    <GenderAgeCard className={styles.GenderCard} hideAge hideUnknown />
    <GenderAgeCard className={styles.AgeCard} hideGender showAgeAsBarChart />
    <CountryCard className={styles.CountryCard} />
    <LanguageEthnicityCard className={styles.LanguageCard} hideEthnicity displayAsBarChart />
  </div>
);
